import { MaintenanceScreen } from 'shared/ui/MaintenanceScreen'

type RootRouteErrorComponentProps = {
  error: unknown
  reset?: () => void
}

export function RootRouteErrorComponent({ error, reset }: RootRouteErrorComponentProps) {
  console.error('Route-level error', error)

  const details = error instanceof Error ? error.message : null

  return (
    <MaintenanceScreen
      details={details}
      onRetry={() => {
        if (reset) {
          reset()
          return
        }

        window.location.reload()
      }}
    />
  )
}
